// These enums are artificial
export enum Warranty {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  UNKNOWN = 'UNKNOWN',
}

export const AssetManagementTabs = {
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned',
  ARCHIVED: 'archived',
} as const;

export enum IsDeviceFilterOption {
  YES = 'YES',
  NO = 'NO',
}

export type AssetManagementTabType =
  (typeof AssetManagementTabs)[keyof typeof AssetManagementTabs];
export const AssetDetailsTabs = {
  Details: 'details',
  Health: 'health',
  History: 'history',
  Images: 'images',
  Security: 'security',
} as const;
